/**
 * Location Map Search
 */

import { type App } from '~/app';

import LlcMpcMapContainer from './LlcMpcMapContainer.vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Map Container Components');
    app.vueApp.component('llc-mpc-map-container', LlcMpcMapContainer);
};
